import React, { useContext, useState } from 'react';
import { AccountContext } from "../../AccountContext";

export default function ReverseTransaction(props) {
    const { accountId, transactionService, interestService, feeService, setError } = useContext(AccountContext);
    const { transactionId, description, balanceMovementType } = props;
    const [reversing, setReversing] = useState(false as boolean);

    const onReverseClicked = async () => {
        try {
            setReversing(true);
            switch (balanceMovementType) {
                case "Interest":
                    await interestService.reverseTransaction(accountId, transactionId, `${description} reversal`);
                    break;
                case "Fee":
                    await feeService.reverseTransaction(accountId, transactionId)
                    break;
                default:
                    await transactionService.reverseTransaction(accountId, transactionId, `${description} reversal`);
                    break;
            }
            setReversing(false);
        } catch (error) {
            setReversing(false);
            setError({ source: 'ReverseTransaction', ...error });
        }
    };

    return (
            <div className="ui labeled input">
                <button className={`ui right floated button ${reversing ? 'loading' : ''}`} onClick={onReverseClicked}>Reverse</button>
            </div>
        );
}